var _g, _path, _g2, _defs, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1020,
    height: 262,
    viewBox: "0 0 1020 262",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,16.794767015441835,17.388157977411936)"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 396 91",
    "data-background-color": "#ffffff",
    preserveAspectRatio: "xMidYMid meet",
    height: 229,
    width: 1020,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "tight-bounds",
    transform: "matrix(1,0,0,1,0.2569339451754331,0.10827194356886594)"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 395.52 90.94085717523107",
    height: 90.94085717523107,
    width: 395.52,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 560.6916693977073 128.9183379501385",
    height: 90.94085717523107,
    width: 395.52,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    width: 5.812994380034127,
    height: 64.78146481994459,
    x: 144.14141224271478,
    y: 32.06843656509695,
    fill: "#ffdc00",
    opacity: 1,
    strokeWidth: 0,
    stroke: "transparent",
    fillOpacity: 1,
    className: "rect-o-0",
    "data-fill-palette-color": "primary",
    rx: "1%",
    id: "o-0",
    "data-palette-color": "#ffdc00"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,165.17166939770735,32.22958448753462)"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 395.52 64.45916897506925",
    height: 64.45916897506925,
    width: 395.52,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "textblocktransform"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 395.52 64.45916897506925",
    height: 64.45916897506925,
    width: 395.52,
    id: "textblock",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 395.52 64.45916897506925",
    height: 64.45916897506925,
    width: 395.52,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    width: 395.52,
    viewBox: "3.0999999046325684 -34.79999923706055 216.58999633789062 35.29999923706055",
    height: 64.45916897506925,
    "data-palette-color": "#ffdc00",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.2-34.8Q21.2-34.8 24.2-33.15 27.2-31.5 28.83-28.43 30.45-25.35 30.45-21.15L30.45-21.15 25.55-21.15Q25.55-25.5 23.4-27.93 21.25-30.35 17.2-30.35L17.2-30.35Q12.7-30.35 10.35-27.58 8-24.8 8-19.4L8-19.4 8-14.9Q8-9.55 10.3-6.75 12.6-3.95 17.1-3.95L17.1-3.95Q21.3-3.95 23.53-6.35 25.75-8.75 25.75-13.05L25.75-13.05 30.45-13.05Q30.45-8.9 28.83-5.85 27.2-2.8 24.2-1.15 21.2 0.5 17.2 0.5L17.2 0.5Q10.55 0.5 6.83-3.58 3.1-7.65 3.1-14.9L3.1-14.9 3.1-19.4Q3.1-26.6 6.83-30.7 10.55-34.8 17.2-34.8L17.2-34.8ZM46.75-34.3L52.15-34.3 65.55 0 60.25 0 57.35-7.45 40.95-7.45 38.1 0 33.35 0 46.75-34.3ZM55.65-11.9L49.35-28.4 49.05-28.4 42.7-11.9 55.65-11.9ZM100.4-34.3L108.05-34.3 108.05 0 103.15 0 103.15-28.55 102.84-28.55 91 0 86.84 0 75.05-28.55 74.8-28.55 74.8 0 70.34 0 70.34-34.3 78.05-34.3 89.09-7.3 89.3-7.3 100.4-34.3ZM117.24-34.3L139.74-34.3 139.09-29.85 122.14-29.85 122.14-19.75 137.49-19.75 137.49-15.3 122.14-15.3 122.14-4.45 139.39-4.45 140.09 0 117.24 0 117.24-34.3ZM146.89-34.3L151.79-34.3 151.79-4.45 167.54-4.45 168.24 0 146.89 0 146.89-34.3ZM171.74-34.3L184.64-34.3 184.64-29.85 180.64-29.85 180.64-4.45 184.64-4.45 184.64 0 171.74 0 171.74-4.45 175.74-4.45 175.74-29.85 171.74-29.85 171.74-34.3ZM200.89-34.3L206.29-34.3 219.69 0 214.39 0 211.49-7.45 195.09-7.45 192.24 0 187.49 0 200.89-34.3ZM209.79-11.9L203.49-28.4 203.19-28.4 196.84-11.9 209.79-11.9Z",
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)",
    fill: "#ffdc00",
    className: "wordmark-text-0",
    "data-fill-palette-color": "primary",
    id: "text-0"
  })))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 128.92414946775634 128.9183379501385",
    height: 128.9183379501385,
    width: 128.92414946775634,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "1.999957799911499 2.002793312072754 59.999969482421875 59.99726486206055",
    x: 0,
    y: 0,
    height: 128.9183379501385,
    width: 128.92414946775634,
    className: "icon-icon-0",
    "data-fill-palette-color": "accent",
    id: "icon-0",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#ffdc00",
    "data-fill-palette-color": "accent"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M61.54 26.82h0A30 30 0 0 0 37.18 2.46a29.42 29.42 0 0 0-7.79-0.34c-0.86 0.07-1.72 0.18-2.56 0.33h0A30 30 0 0 0 2.46 26.82 28.84 28.84 0 0 0 2 32c0 0.48 0 1 0 1.43a28.72 28.72 0 0 0 0.42 3.74h0A30 30 0 0 0 26.82 61.54 28.76 28.76 0 0 0 32 62c0.46 0 0.91 0 1.37 0a29.84 29.84 0 0 0 3.8-0.42h0A30 30 0 0 0 61.54 37.18a29.4 29.4 0 0 0 0-10.36ZM59.9 34.24c0 0.24 0 0.48-0.08 0.72s-0.08 0.7-0.14 1H44.38c0.12-0.37 0.21-0.75 0.3-1.13l0.06-0.31c0.06-0.32 0.11-0.63 0.15-1 0-0.12 0-0.24 0-0.36 0-0.41 0.07-0.83 0.07-1.25s0-0.84-0.07-1.25c0-0.12 0-0.24 0-0.36 0-0.32-0.09-0.64-0.15-0.95l-0.06-0.31c-0.09-0.38-0.18-0.76-0.3-1.13h15.3c0.06 0.34 0.1 0.69 0.14 1s0.06 0.49 0.08 0.73c0.06 0.74 0.1 1.49 0.1 2.24S60 33.5 59.9 34.24ZM59.32 26H43.53A13.11 13.11 0 0 0 38 20.47V4.68A28 28 0 0 1 59.32 26ZM42 36.58A11.06 11.06 0 0 1 36.59 42a11.11 11.11 0 0 1-9.17 0A11 11 0 0 1 21 32a10.91 10.91 0 0 1 1-4.58A11.06 11.06 0 0 1 27.41 22a11.19 11.19 0 0 1 9.17 0A11 11 0 0 1 43 32 10.91 10.91 0 0 1 42 36.58ZM34.94 59.82l-0.69 0.08c-0.75 0.06-1.49 0.1-2.24 0.1h0c-0.75 0-1.5 0-2.25-0.1l-0.69-0.07c-0.35 0-0.71-0.09-1.06-0.15V44.38c0.37 0.12 0.74 0.21 1.12 0.3l0.36 0.07 0.87 0.14 0.43 0c0.36 0 0.72 0.05 1.08 0.05h0.28c0.36 0 0.72 0 1.08-0.05l0.43 0 0.87-0.14 0.36-0.07c0.38-0.09 0.75-0.18 1.12-0.3v15.3C35.65 59.74 35.3 59.79 34.94 59.82ZM29 4.18l0.74-0.08C30.45 4 31.13 4 31.82 4h0.36c0.69 0 1.37 0 2.06 0.09l0.73 0.08c0.34 0 0.69 0.08 1 0.14v15.3c-0.39-0.12-0.8-0.22-1.2-0.31l-0.12 0c-0.4-0.08-0.8-0.14-1.21-0.19h-0.14a11.1 11.1 0 0 0-2.66 0h-0.13a12.13 12.13 0 0 0-1.23 0.2l-0.1 0c-0.41 0.08-0.81 0.19-1.21 0.31V4.31Zm-3 0.5V20.47A13.06 13.06 0 0 0 20.47 26H4.68A28 28 0 0 1 26 4.68ZM19.62 36H4.32c-0.06-0.34-0.1-0.69-0.14-1s-0.06-0.49-0.08-0.73C4 33.5 4 32.75 4 32s0-1.5 0.1-2.24c0-0.24 0.05-0.48 0.08-0.72s0.08-0.7 0.14-1h15.3c-0.12 0.37-0.21 0.75-0.3 1.13l-0.06 0.31c-0.06 0.32-0.11 0.63-0.15 0.95 0 0.12 0 0.24 0 0.36 0 0.41-0.07 0.83-0.07 1.25s0 0.84 0.07 1.25c0 0.12 0 0.24 0 0.36 0 0.32 0.09 0.64 0.15 1l0.06 0.31C19.41 35.25 19.5 35.63 19.62 36ZM4.68 38H20.47A13.11 13.11 0 0 0 26 43.53V59.32A28 28 0 0 1 4.68 38ZM38 59.32V43.53A13.11 13.11 0 0 0 43.53 38H59.32A28 28 0 0 1 38 59.32Z",
    fill: "#ffdc00",
    "data-fill-palette-color": "accent"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.83 44.17A4 4 0 1 0 52 47 4 4 0 0 0 50.83 44.17Zm-1.42 4.24a2 2 0 0 1-2.82 0 2 2 0 1 1 2.82 0Z",
    fill: "#ffdc00",
    "data-fill-palette-color": "accent"
  }))))))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 395.52,
    height: 90.94085717523107,
    fill: "none",
    stroke: "none",
    visibility: "hidden"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.1dde25e6bb4654effc46acdbb22b453d.svg";
export { ForwardRef as ReactComponent };